import { createContext } from "react";

// This theme can be expanded at any time
export type Theme = "dark" | "default";

/**
 * Type guard for Theme
 */
export const isValidTheme = (value: unknown): value is Theme =>
  value === "dark" || value === "default";

export interface ThemeProviderState {
  theme: Theme;
  setTheme: (theme: Theme) => void;
}

export const initialState: ThemeProviderState = {
  theme: "default",
  setTheme: () => {
    // Intentionally left empty
  },
};

export const ThemeProviderContext =
  createContext<ThemeProviderState>(initialState);
